import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { genericUnitField } from './common/sharedFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { msg } from '@lingui/core/macro';
import {
  cloudServiceField,
  cloudVmInstanceTypeField,
  cloudRegionField,
} from './common/cloudFields';

export const cloudComputeUsageMetadata = {
  displayName: msg({
    message: 'Cloud usage',
    context: 'Activity data schema name for cloud compute usage',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    cloud_region: cloudRegionField,
    cloud_service: cloudServiceField,
    cloud_vm_instance_type: cloudVmInstanceTypeField,
    quantity: {
      displayName: msg({
        message: 'Cloud instance hours',
        context: 'Quantity of cloud compute instance hours used.',
      }),
      externalDescription: msg({
        message: 'Quantity of cloud compute instance hours used.',
        context: 'Cloud compute usage',
      }),
    },
    unit: genericUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
